import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInProgress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 12 12"
    {...props}
  >
    <path d="M6.3 2.1c0 .394-.328.7-.7.7a.69.69 0 0 1-.7-.7V.7c0-.372.306-.7.7-.7.372 0 .7.328.7.7zm0 8.4c0 .394-.328.7-.7.7a.69.69 0 0 1-.7-.7V9.1c0-.372.306-.7.7-.7.372 0 .7.328.7.7zM0 5.6c0-.372.306-.7.7-.7h1.4c.372 0 .7.328.7.7 0 .394-.328.7-.7.7H.7a.69.69 0 0 1-.7-.7m10.5-.7c.372 0 .7.328.7.7 0 .394-.328.7-.7.7H9.1a.69.69 0 0 1-.7-.7c0-.372.306-.7.7-.7zM1.619 1.64a.74.74 0 0 1 1.006 0l.984 1.007c.263.262.263.7 0 .984a.71.71 0 0 1-.984 0l-1.006-.984a.74.74 0 0 1 0-1.006Zm7.94 6.935c.263.284.263.722 0 .984a.7.7 0 0 1-1.006 0l-.984-.984a.714.714 0 0 1 0-.984c.284-.285.722-.285.984 0zm-7.94.984c-.263-.262-.263-.7 0-.984l1.006-.984c.263-.285.7-.285.984 0a.714.714 0 0 1 0 .984l-.984.984a.7.7 0 0 1-1.006 0m6.934-7.918a.74.74 0 0 1 1.006 0 .74.74 0 0 1 0 1.006l-1.006.984c-.262.263-.7.263-.984 0-.263-.284-.263-.722 0-.984z" />
  </svg>
);
export default SvgInProgress;
